import script from "./bodyView.vue?vue&type=script&lang=ts&setup=true"
export * from "./bodyView.vue?vue&type=script&lang=ts&setup=true"

import "./bodyView.vue?vue&type=style&index=0&id=26df724c&lang=css"

const __exports__ = script;

export default __exports__